import React from "react";
import PropTypes from "prop-types";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import Help from "@material-ui/icons/Help";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

const StyledHelp = styled(Help)`
  width: 27px !important;
`;

const StyledBlock = styled.div`
  padding: 5px;
  max-width: 350px;
`;

const styles = theme => ({
  paper: {
    padding: "10px"
  }
});

class RentalPopOver extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { key } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          variant="display4"
          onClick={this.handleClick}
        >
          <StyledHelp />
        </Typography>
        <Popover
          id="simple-popper"
          key={`${key}_p`}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <StyledBlock>{this.props.children}</StyledBlock>
        </Popover>
      </div>
    );
  }
}

RentalPopOver.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.string
};

export default withStyles(styles)(RentalPopOver);



// WEBPACK FOOTER //
// ./src/components/rentalPopOver.js